import { Card } from './Card'
import clsx from 'clsx'

export const Employee9BoxTalentMatrix = ({ data, isLoading, filter, onSubmitFilter, years }) => {
    return (
        <Card
            isLoading={isLoading}
            title='9-Box Talent Matrix'
            filterTitle='Filter Employee 9 Box Talent Matrix'
            initFilter={filter}
            initOptions={{ year: years }}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='relative w-full pl-10 pt-2'>
                <div className='absolute left-[-25px] top-1/2 -translate-y-7 rotate-[-90deg] text-sm font-semibold text-neutral-60 uppercase'>
                    Potential
                </div>
                <div className='grid grid-cols-3 gap-3 text-xs font-semibold'>
                    {data?.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                gridRowStart: 4 - item?.position?.row,
                                gridColumnStart: item?.position?.col,
                            }}
                        >
                            <MatrixBox
                                bgColor={item?.bgColor}
                                textColor={item?.textColor}
                                descriptionColor={item?.descriptionColor}
                                title={item?.nine_box_label}
                                description={item?.description}
                                count={item?.count}
                                percentage={item?.percentage}
                            />
                        </div>
                    ))}
                </div>
                <div className='grid grid-cols-3 text-center mt-5 text-sm font-semibold text-neutral-60 uppercase'>
                    <div>Low</div>
                    <div className='flex flex-col space-y-5'>
                        <p>Moderate</p>
                        <p>Performance</p>
                    </div>
                    <div>High</div>
                </div>
                <div className='absolute left-[-25px] top-1/2 -translate-y-7 rotate-[-90deg] text-sm font-semibold text-neutral-60 uppercase'>
                    Potential
                </div>
            </div>
        </Card>
    )
}

const MatrixBox = ({ title, description, count, percentage, bgColor, descriptionColor, textColor }) => {
    return (
        <div className={clsx('p-3 rounded-lg', bgColor, textColor)}>
            <div className='text-sm'>
                {count} ({percentage}%)
            </div>
            <div className='capitalize text-xs font-semibold'>{title}</div>
            <div className={clsx(descriptionColor || 'text-neutral-70')}>{description}</div>
        </div>
    )
}
